import React from 'react';

type Props = {
  width: number;
};

const Sfr = ({ width }: Props) => (
  <svg viewBox="0 0 45 44" xmlns="http://www.w3.org/2000/svg" width={width} className="margin: 10px">
    <path d="m44.074 0h-44v44h44v-44z" fill="#E2001A" />
    <path
      d="m21.827 28.465v-13.601h8.3139v2.1483h-6.0755v3.7254h5.231v2.1111h-5.231v5.616h-2.2384zm17.752 0-3.0424-5.4763h-2.2725v5.4763h-2.2383v-13.601h5.0231c2.021 0 4.7188 0.5681 4.7188 3.952 0 2.3005-1.1921 3.3653-3.0735 3.862l3.5361 5.7868h-2.6575 0.0062zm-2.8033-7.5098c2.0272 0 2.6636-0.8661 2.6636-2.1638 0-0.8569-0.3849-1.9186-2.586-1.9186h-2.5861v4.0824h2.5085zm-22.34-0.7482c-1.6143-0.4532-1.8037-1.3038-1.8037-1.8564 0-1.0556 0.8165-1.7634 2.288-1.7634 1.0152 0 1.9124 0.4346 2.5674 1.3008l1.7727-1.0338c-0.8599-1.2635-2.1918-2.316-4.3463-2.316-2.5426 0-4.6288 1.5802-4.6288 3.9117s1.9714 3.3404 4.0731 3.9303c0 0 0.9655 0.2794 0.9748 0.2825 1.8037 0.475 1.9434 1.2915 1.9434 1.9962 0 1.2883-1.3504 2.0862-2.5177 2.0862s-2.1887-0.4005-2.9741-1.7944l-1.7727 1.0555c1.1487 1.9745 2.5271 2.7786 4.7592 2.7786 2.4619 0 4.843-1.8783 4.843-4.2253 0-2.7785-2.2538-3.5639-4.2035-4.07-0.0093 0-0.9717-0.2794-0.9717-0.2794l-0.0031-0.0031z"
      fill="var(--theme-palette-white)"
    />
  </svg>
);

export default Sfr;
